import React from 'react';
import { CloseOutlined } from '@ant-design/icons';

const Delete = ({ data, action }) => {
	return (
		<>        
			<div onClick={action.bind(this, data)} style={{cursor:'pointer'}}>
				<CloseOutlined style={{color:'#f81d22'}} type="close" />
			</div>
		</>
	);
};
export default Delete;
